export const DOUBLE_RUN_ROUTE = "Double Run Route";
export const DOUBLE_RUN_ROUTE_MESSAGE_PT_1 =
  "Please Make Sure The Original Route Is Departed";
export const DOUBLE_RUN_ROUTE_MESSAGE_PT_2 =
  "Before Proceeding Otherwise It Will Be Unusable";
